import { cn } from "../utils";
import { Text } from "./Text";

const BidItemLabel = ({
  className,
  text,
  accentColor,
}: {
  className?: string;
  text: string;
  accentColor?: "mint" | "primary";
}) => {
  return (
    <div
      className={cn(
        "h-[22px] rounded-t-sm rounded-r-sm mt-[5px] ml-[-9.5px] text-xs flex items-center px-3 bg-gray-500 relative",
        {
          "bg-mint-500": accentColor === "mint",
          "bg-primary": accentColor === "primary",
        },
        className,
      )}
    >
      <div
        className={cn(
          "transform rotate-90 absolute left-0 bottom-0 mb-[-9.5px] border-t-10 border-gray-600 border-l-0 border-r-10 border-r-transparent",
          {
            "border-t-primary brightness-50": accentColor === "primary",
            "border-t-mint-500 brightness-50": accentColor === "mint",
          },
        )}
      />
      <Text className="text-sm text-nowrap font-semibold leading-none text-white">
        {text}
      </Text>
    </div>
  );
};

export default BidItemLabel;
